module.exports = __webpack_public_path__ + "fonts/PingFangSCRegular.c42f2cf1.ttf";